export const VUEX_FILEPROGRESS_SHOW = 'VUEX_FILEPROGRESS_SHOW'
export const VUEX_FILEPROGRESS_SHOW_MINI = 'VUEX_FILEPROGRESS_SHOW_MINI'
export const VUEX_FILEPROGRESS_HIDE = 'VUEX_FILEPROGRESS_HIDE'
export const VUEX_FILEPROGRESS_DISPLAY_STATE_TOGGLE = 'VUEX_FILEPROGRESS_DISPLAY_STATE_TOGGLE'

export const VUEX_FILEPROGRESS_OPEN = 'VUEX_FILEPROGRESS_OPEN'
export const VUEX_FILEPROGRESS_CLOSE = 'VUEX_FILEPROGRESS_CLOSE'
export const VUEX_FILEPROGRESS_OPEN_STATE_TOGGLE = 'VUEX_FILEPROGRESS_OPEN_STATE_TOGGLE'
